import React from 'react';

import { useNavigate } from 'react-router-dom';

import { Settings, X } from 'lucide-react';

interface ConfigSetupModalProps {
	isOpen: boolean;
	onClose: () => void;
	showViewPlans?: boolean;
}

const ConfigSetupModal: React.FC<ConfigSetupModalProps> = ({
	isOpen,
	onClose,
	showViewPlans = false,
}) => {
	const navigate = useNavigate();

	if (!isOpen) return null;

	return (
		<div className="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4">
			<div className="bg-white rounded-2xl shadow-2xl w-full max-w-md font-primary">
				<div className="flex items-center justify-between p-6 border-b border-neutral-200">
					<div className="flex items-center">
						<Settings className="h-6 w-6 text-primary-600 mr-3" />
						<h2 className="text-xl font-semibold text-neutral-900 font-primary">
							Configure Your Setup
						</h2>
					</div>
					<button
						onClick={onClose}
						className="text-neutral-400 hover:text-neutral-600 transition-colors"
					>
						<X className="h-6 w-6" />
					</button>
				</div>

				<div className="p-6">
					<p className="text-neutral-600 mb-6 leading-relaxed font-primary">
						Before continuing, please configure your interchange rate settings.
						This ensures your analysis is tailored to your business.
					</p>

					<div className="space-y-3">
						<button
							onClick={() => {
								onClose();
								navigate('/config');
							}}
							className="w-full flex items-center justify-center px-4 py-3 bg-gradient-to-r from-primary-600 to-primary-600 text-white rounded-lg hover:from-primary-700 hover:to-primary-700 transition-all duration-200 font-medium font-primary"
						>
							<Settings className="h-5 w-5 mr-2" />
							Go to Config
						</button>

						{showViewPlans && (
							<button
								onClick={() => {
									onClose();
									navigate('/subscription');
								}}
								className="w-full flex items-center justify-center px-4 py-3 bg-gradient-to-r from-success-600 to-success-600 text-white rounded-lg hover:from-success-700 hover:to-success-700 transition-all duration-200 font-medium font-primary"
							>
								💳 View Plans
							</button>
						)}

						<button
							onClick={onClose}
							className="w-full px-4 py-3 border border-neutral-300 text-neutral-700 rounded-lg hover:bg-neutral-50 transition-colors font-primary"
						>
							Cancel
						</button>
					</div>
				</div>
			</div>
		</div>
	);
};

export default ConfigSetupModal;
